import { useQuery } from "react-query";

import { zodParseWithDetailedLog } from "src/api/apiErrorLogs";
import { loggedInApiCall } from "src/api/axiosClient/userApi";

import { GeographySchema, getOneGeographyApiKey, type Geography } from "./geographySchema";

export const useGetOneGeography = (code: string | null | undefined, options?: { enabled?: boolean }) => {
    const { enabled = true } = options ?? {};
    const normalizedCode = code?.trim() ?? "";
    const isEnabled = enabled && normalizedCode !== "";

    const query = useQuery({
        queryKey: [getOneGeographyApiKey, normalizedCode],
        queryFn: async () => {
            return await loggedInApiCall.get(`/api/geographies/${encodeURIComponent(normalizedCode)}`);
        },
        select: (response): Geography => {
            return zodParseWithDetailedLog(response.data, GeographySchema, {
                operation: "GET",
                endpoint: "/geographies/:code",
            });
        },
        enabled: isEnabled,
        staleTime: 300_000,
        cacheTime: 300_000,
    });

    return {
        geography: query.data,
        ...query,
    };
};
